export enum MediaActivityType {
    MediaViewed = 'MediaViewed',
    MediaEngagement25 = 'MediaEngagement25',
    MediaEngagement50 = 'MediaEngagement50',
    MediaEngagement70 = 'MediaEngagement70',
    MediaEngagement75 = 'MediaEngagement75',
    MediaEngagement100 = 'MediaEngagement100'
}
